export default "__VITE_ASSET__WSWBoeBN__"